export function validarPassword(password1, password2) {
	return (password1 && password1 == password2);
}

export function validarEmail(email) {
	if (! email) {
		return false;
	}

	const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	return email.toLowerCase().match(regexp) ? true : false;
}

export function validarTelefono(telefono) {
	if (telefono && ! isNaN(telefono) && telefono.length == 9) {
		const primerDigito = parseInt(telefono.charAt(0));
		if (primerDigito >= 6 && primerDigito <= 9) {
			return true;
		}
	}

	return false;
}

export function validarFecha(fecha) {
	if (! fecha) {
		return false;
	}

	const dia = parseInt(fecha.substring(0, 2));
	const mes = parseInt(fecha.substring(3, 5));
	const anno = parseInt(fecha.substring(6));

	if (isNaN(dia) || isNaN(mes) || isNaN(anno)) {
		return false;
	}

	if (dia < 1 || dia > 31 || mes < 1 || mes > 12 || anno < 1900) {
		return false;
	}

	return true;
}

export function validarNIF(nif) {
	if (! nif) {
		return false;
	}

	nif = nif.trim().toUpperCase();

	const regexp = /^[XYZ]?\d{5,8}[A-Z]$/;

	if (nif.match(regexp)) {
		let base = nif.substr(0, nif.length-1);
		const letraOriginal = nif.substr(nif.length-1, 1);
		base = base.replace('X', '0').replace('Y', '1').replace('Z', '2');

		const letrasNif = 'TRWAGMYFPDXBNJZSQVHLCKE';
		const letraEsperada = letrasNif.charAt(parseInt(base, 10) % 23);
		if (letraEsperada == letraOriginal) {
			return true;
		}
	}
	return false;
}

export function validarIBAN(iban) {
	if (! iban) {
		return false;
	}

	iban = iban.replace(/ /g, '');

	if (iban.substring(0, 2) != 'ES' || iban.length != 24) {
		return false;
	}

	let ibanCheck = iban.substring(4) + iban.substring(0, 4);
	ibanCheck = ibanCheck.replace(/E/g, '14').replace(/S/g, '28');

	// Javascript no es capaz de hacer módulo 97 sobre números tan grandes,
	// este código lo he encontrado en varios sitios y funciona
    let checksum = ibanCheck.slice(0, 2);
	let fragment = '';
    for (var offset = 2; offset < ibanCheck.length; offset += 7) {
        fragment = String(checksum) + ibanCheck.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }

	return (checksum == 1)
}
